// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-200131b0] .modal-backdrop{opacity:.87!important}.shadow-take-photo-itineraries[data-v-200131b0]{-webkit-box-shadow:0 4px 10px 0 rgba(0,0,0,.3019607843);box-shadow:0 4px 10px 0 rgba(0,0,0,.3019607843)}", ""]);
// Exports
module.exports = exports;
